/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {CSSProperties} from "react";
import {FONTS} from "@res/fonts";

type Props = {
    text: string
    textStyle?: CSSProperties
    wrapperStyle?: CSSProperties
    enabled: boolean
    onClick: () => void
    inverted?: boolean
}

export function OKButton({enabled, onClick, text, textStyle, wrapperStyle, inverted}: Props) {
    const isInverted = inverted === true;
    const FontWrapper = inverted ? FONTS.medium_16_primary_blue : FONTS.medium_16_white;
    return <div className={`flex_center okBtn ${enabled ? "enabled" : ""} ${isInverted ? "inverted" : ""}`}
                onClick={() =>
                    enabled && onClick()
                }
                style={wrapperStyle}>
        {FontWrapper(text, {padding: '5px 15px', ...textStyle})}
    </div>;
}
